export default "__VITE_ASSET__Dt7fz7Nu__"